<form [formGroup]="formCard" class="space-y-5">
  <h1 class="text-vivid-royal-500 dark:text-dark-khaki-50 text-lg md:text-xl">Cambio de NIP</h1>

  @if(userWantsChange) {
    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Nuevo NIP</label>
        <div class="relative mt-1">
          <input pInputText [type]="showNip ? 'text' : 'password'" formControlName="nip" maxlength="4" inputmode="numeric" class="w-full pr-10" />
          <button type="button" tabindex="-1" class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600" (click)="showNip = !showNip">
            <i class="pi" [ngClass]="showNip ? 'pi-eye-slash' : 'pi-eye'"></i>
          </button>
        </div>
        @if(nip.touched && nip.errors?.['required']) {
          <small class="text-red-500">El NIP no puede estar vacío</small>
        }
        @if(nip.touched && nip.errors?.['pattern']) {
          <small class="text-red-500">El NIP debe ser numérico y de 4 dígitos</small>
        }
      </div>
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Confirmar NIP</label>
        <div class="relative mt-1">
          <input pInputText [type]="showNipConfirm ? 'text' : 'password'" formControlName="nipConfirmation" maxlength="4" inputmode="numeric" class="w-full pr-10"
            [ngClass]="{'border-red-400': nipConfirm.touched && nipConfirm.errors?.['notSame'], 'border-green-400': nipConfirm.touched && !nipConfirm.errors && nip.valid}" />
          <button type="button" tabindex="-1" class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600" (click)="showNipConfirm = !showNipConfirm">
            <i class="pi" [ngClass]="showNipConfirm ? 'pi-eye-slash' : 'pi-eye'"></i>
          </button>
        </div>
        @if(nipConfirm.touched && nipConfirm.errors?.['pattern']) {
          <small class="text-red-500">El NIP debe ser numérico y de 4 dígitos</small>
        }
        @if(nipConfirm.touched && nipConfirm.errors?.['notSame'] && !nipConfirm.errors?.['pattern']) {
          <small class="text-red-500">Los NIPs ingresados no coinciden</small>
        }
        @if(nipConfirm.touched && !nipConfirm.errors && nip.valid) {
          <small class="text-green-600 flex items-center gap-1"><i class="pi pi-check-circle text-xs"></i> Los NIPs coinciden</small>
        }
      </div>
    </div>

    @if(showMessageError) {
      <div class="text-sm text-red-700 bg-red-100 border border-red-300 rounded-lg px-3 py-2">{{ messagesError }}</div>
    }

    <div class="flex justify-end">
      <button pButton label="Guardar" icon="pi pi-check" class="p-button-sm" type="button"
        [disabled]="formCard.invalid" (click)="saveNIP()"></button>
    </div>
  } @else {
    <div class="bg-vivid-royal-50 dark:bg-vivid-royal-900 border border-vivid-royal-200 dark:border-vivid-royal-700 rounded-lg p-4">
      <p class="text-sm text-vivid-royal-600 dark:text-vivid-royal-200">
        <i class="pi pi-lock mr-2"></i>Por seguridad no mostramos el NIP actual del dispositivo. Si desea crear uno nuevo, presione el siguiente botón.
      </p>
    </div>
    <div class="flex justify-end">
      <button pButton label="Cambiar mi NIP" icon="pi pi-key" class="p-button-sm p-button-outlined" type="button" (click)="userWantsChange=true"></button>
    </div>
  }
</form>
